import $ from 'jquery';
import 'hc-sticky';
import Swiper from 'swiper/bundle'
import imagesLoaded from 'imagesloaded';

imagesLoaded.makeJQueryPlugin($);

// eslint-disable-next-line no-undef
const object = gralObject;

const initializeBlock = ($block) => {
    $block.find('.smile').each( function() {
        const id = $( this ).attr('data-id');
        const desktopWrapper = $( this ).find('.smile__screen--desktop');
        const tabletWrapper = $( this ).find('.smile__screen--tablet');
        const mobileWrapper = $( this ).find('.smile__screen--mobile');

        const data = {
            id,
            action: 'gral_advertisement',
            nonce: object.nonce,
        };

        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            dataType: 'JSON',
            data,
            success: (res) => {
                if (res.success) {
                    setTimeout(() => {
                        desktopWrapper.html(res.data.desktopContent);
                        tabletWrapper.html(res.data.tabletContent);
                        mobileWrapper.html(res.data.mobileContent);

                        $block.imagesLoaded(function () {
                            if ($block.hasClass('smile--vertical')) {
                                $block.find('.smile__screen--tablet').hcSticky({
                                    top: $('#wpadminbar').length
                                        ? $('#wpadminbar').height() + 30
                                        : 30,
                                });
                            }
                        });
                    }, 1000);
                }
            },
        });
    })

    const el = $block.find('.smile__slider')

    new Swiper(el[0], {
        slidesPerView: 1,
        watchOverflow: false,
        effect: 'fade',
        autoplay: {
            delay: 5000,
        },
    })
};

$('.smile-block').each(function () {
    initializeBlock($(this));
});

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=gral-advertisement',
        initializeBlock
    );
}

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=gral-recipes',
        initializeBlock
    );
}

